import { UsState } from '@/components/EstimateWidget/FloatingVariation/FloatingForm/experiments/FinalExpenseInfoForm/utils/constants'

import {
  ATTORNEY_REVIEW_ELIGIBLE_STATES,
  WILLS_V3_12_CONTROL_FLOW,
  WILLS_V3_12_FLOWS,
} from '@/hooks/features/useWillsFunnelFlow'

import { getClientLocation } from './getClientLocation'
import { getStateAbbreviation } from './getStateAbbreviation'

export const getWillsRedirectUrl = async ({
  willsFlow,
  willsControlFlow,
}: {
  willsFlow?: string
  willsControlFlow: string
}): Promise<{ url: string; region?: string }> => {
  let redirectUrl = willsFlow
    ? `/app/flow/${willsFlow}`
    : `/app/flow/${willsControlFlow}`

  let region: string | undefined

  if (willsFlow && WILLS_V3_12_FLOWS.includes(willsFlow)) {
    try {
      const location = await getClientLocation()
      region = location?.region
        ? getStateAbbreviation(location.region)
        : undefined

      if (!ATTORNEY_REVIEW_ELIGIBLE_STATES.includes(region as UsState)) {
        redirectUrl = `/app/flow/${WILLS_V3_12_CONTROL_FLOW}`
      }
    } catch (e) {
      console.error('Failed to get location from ipinfo.io', e)
    }
  }

  return { url: redirectUrl, region }
}
